/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { useEffect, useState } from 'react'
import { Link, navigate, graphql, useStaticQuery } from 'gatsby'

import AccordionArrow from '~/icons/accordionArrow'
import Footer from '~/components/footer'
import Cart from '~/components/Cart'
import Navigation from '~/components/Navigation'

import '~/styles/reset.css'
import '~/styles/fonts.css'
import '~/styles/utility.css'
import '~/styles/master.css'
import '~/styles/journal.css'

const Layout = ({
  title,
  pageTitle,
  children,
  hideFooter = false,
  hideCart = false,
  whiteBackground = false,
  darkMode = false
}) => {
  const [reservationsHovered, setReservationsHovered] = useState(false)
  const [reservationsOpen, setReservationsOpen] = useState(false)

  const data = useStaticQuery(graphql`
    query layoutQuery {
      allSanityHome {
        nodes {
          storeLabel
          storeEnabled
        }
      }
    }
  `)

  const { storeLabel, storeEnabled } = data.allSanityHome.nodes[0]

  useEffect(() => {
    const navigationToggle = document.querySelector('.js-navigation-toggle')
    const navigationModal = document.querySelector('.js-navigation-modal')
    const accordionMenu = document.querySelector('.js-accordion')
    // const holidayModal = document.querySelector(".js-holiday-modal");
    // const holidayClose = document.querySelector(".js-modal-close");

    // if (window) {
    //   const modalSeen = window.localStorage.getItem("~~planqueModal");
    //   if (modalSeen !== "TRUE") {
    //     setTimeout(() => {
    //       holidayModal.classList.add("is-active");
    //     }, 2000);
    //   }
    // }

    // holidayClose.addEventListener("click", function () {
    //   holidayModal.classList.toggle("is-active");
    //   if (window) {
    //     window.localStorage.setItem("~~planqueModal", "TRUE");
    //   }
    // });

    accordionMenu.classList.remove('is-transitioning')

    const modalLinks = document.querySelectorAll('.js-navigation-modal a')
    modalLinks.forEach((link) => {
      if (link.href === window.location.href) {
        link.classList.add('is-active')
      }
    })

    navigationToggle.addEventListener('click', function () {
      navigationToggle.classList.toggle('is-active')

      if (navigationModal.classList.contains('is-active')) {
        navigationModal.classList.toggle('is-active')
        setTimeout(() => {
          navigationModal.classList.toggle('has-transition')
        }, 500)
      } else {
        navigationModal.classList.toggle('has-transition')
        setTimeout(() => {
          navigationModal.classList.toggle('is-active')
        }, 0)
      }
    })

    function setDate() {
      const date = document.querySelector('.js-date')
      const formatted = new Date().toLocaleString('en-US', {
        month: 'long',
        day: '2-digit',
        year: 'numeric'
      })
      date.innerText = formatted.replace(',', '')
    }

    setDate()
  }, [])

  let links = [{ title: 'Reservations', link: '/restaurant' }]

  if (pageTitle === 'Shop') {
    links = []
  }

  if (storeEnabled && pageTitle !== 'Shop') {
    links.push({ title: 'Store', link: '/store' })
  }

  const slowlyNavigate = (link) => {
    const accordionMenu = document.querySelector('.js-accordion')
    accordionMenu.classList.add('is-transitioning')
    setReservationsHovered(false)

    setTimeout(() => {
      navigate(link)
      accordionMenu.classList.remove('is-transitioning')
    }, 600)
  }

  return (
    <>
      <div
        sx={{
          backgroundColor: whiteBackground
            ? 'white'
            : darkMode
              ? '#1d1d1b'
              : '',
          minHeight: '100vh',
          ...(darkMode && {
            color: 'white'
          })
        }}
      >
        {title !== 'Home' && (
          <header sx={{ zIndex: 3 }}>
            <Link to="/" sx={{ width: '100%' }}>
              <svg
                viewBox="0 0 183 31"
                fill="none"
                sx={{
                  aspectRatio: 5.903,
                  width: '100%',
                  maxWidth: [183, 344]
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M123.129 26.5047C123.624 27.9925 124.444 29.114 125.583 29.8693C126.722 30.6246 128.05 31 129.568 31.0046C130.437 31.0046 131.197 30.9039 131.855 30.7025C132.512 30.501 133.138 30.1989 133.732 29.7961L132.652 26.8847C131.859 27.4889 130.941 27.7911 129.901 27.7911C128.91 27.7911 128.095 27.5667 127.465 27.1273C126.834 26.6878 126.344 26.0103 125.997 25.104C127.906 23.8726 129.405 22.2521 130.495 20.247C131.585 18.242 132.13 16.031 132.13 13.6094C132.13 11.1146 131.54 8.82575 130.365 6.74749C129.185 4.66923 127.573 3.02126 125.529 1.81276C123.484 0.604253 121.197 0 118.667 0C116.136 0 113.849 0.604253 111.805 1.81734C109.756 3.03042 108.153 4.6738 106.987 6.75207C105.821 8.83033 105.24 11.1192 105.24 13.614C105.24 16.1088 105.821 18.3977 106.987 20.4759C108.153 22.5542 109.76 24.2022 111.805 25.4107C113.849 26.6192 116.136 27.2234 118.667 27.2234C120.153 27.2234 121.643 26.9808 123.129 26.5047ZM114.817 16.0676C113.687 17.1022 113.124 18.4526 113.124 20.1143C113.124 21.0985 113.336 21.9683 113.754 22.7144C112.219 21.8813 111.008 20.6773 110.13 19.1026C109.252 17.5279 108.81 15.7106 108.81 13.6415C108.81 11.5998 109.238 9.79164 110.094 8.21692C110.949 6.6422 112.129 5.42454 113.628 4.56852C115.128 3.71249 116.807 3.28219 118.667 3.28219C120.526 3.28219 122.206 3.71249 123.705 4.56852C125.204 5.42454 126.384 6.63763 127.24 8.19861C128.095 9.7596 128.523 11.5632 128.523 13.6048C128.523 15.2162 128.248 16.681 127.703 17.9903C127.159 19.304 126.402 20.4118 125.434 21.3182V21.0161C125.263 18.8737 124.637 17.2578 123.557 16.1592C122.48 15.0651 120.986 14.5158 119.076 14.5158C117.365 14.5158 115.943 15.0331 114.817 16.0676ZM122.57 22.6457C122.57 22.8975 122.579 23.0852 122.606 23.2134C121.467 23.694 120.252 23.9321 118.964 23.9321C117.946 23.9321 117.145 23.6071 116.564 22.9662C115.983 22.3253 115.69 21.4876 115.69 20.453C115.69 19.5467 115.983 18.8051 116.564 18.2237C117.149 17.6424 117.897 17.354 118.815 17.354C120.031 17.354 120.945 17.7843 121.566 18.6403C122.188 19.4963 122.521 20.833 122.57 22.6457ZM3.42199 26.8435H0V0.379944H11.4907C13.2737 0.379944 14.8001 0.727847 16.0653 1.41908C17.3306 2.11488 18.2896 3.0533 18.947 4.23434C19.6044 5.41996 19.9331 6.72917 19.9331 8.16656C19.9331 9.5536 19.5999 10.8445 18.929 12.0393C18.2581 13.2386 17.2856 14.1908 16.0113 14.8957C14.7326 15.6007 13.2287 15.9532 11.4952 15.9532H3.42199V26.8435ZM11.1935 12.6664C12.7289 12.6664 13.9716 12.2773 14.9127 11.4945C15.8537 10.7118 16.3265 9.60395 16.3265 8.16656C16.3265 6.72917 15.8537 5.62138 14.9127 4.8386C13.9716 4.05581 12.7289 3.66671 11.1935 3.66671H3.42199V12.6664H11.1935ZM28.4476 0.379944V23.5567H44.3643V26.848H25.0256V0.379944H28.4476ZM62.6224 0.379944H57.8631L46.9668 26.8435H50.722L53.4371 20.1143H67.0485L69.7276 26.8435H73.5188L62.6224 0.379944ZM60.245 3.1357L65.7833 16.9374H54.6663L60.245 3.1357ZM80.7725 26.8435H77.3505V0.379944H83.2264L96.7612 24.4265V0.379944H100.183V26.8435H94.2713L80.7725 2.79695V26.8435ZM140.306 0.379944V15.9166C140.306 18.4618 140.959 20.4347 142.26 21.8355C143.562 23.2363 145.34 23.9321 147.596 23.9321C149.879 23.9321 151.666 23.2317 152.968 21.8355C154.269 20.4393 154.922 18.4663 154.922 15.9166V0.379944H158.344V16.2599C158.344 18.3794 157.911 20.2654 157.042 21.9316C156.173 23.5933 154.935 24.8934 153.323 25.8272C151.711 26.7611 149.802 27.228 147.596 27.228C145.412 27.228 143.512 26.7611 141.887 25.8272C140.261 24.8934 139.023 23.5979 138.167 21.9316C137.312 20.2699 136.884 18.3794 136.884 16.2599V0.379944H140.306ZM182.626 3.66671V0.379944H164.292V26.848H182.996V23.5567H167.714V14.7859H181.51V11.4945H167.714V3.66671H182.626Z"
                  fill="currentColor"
                />
              </svg>
            </Link>
          </header>
        )}

        <div
          className="navigation-toggle js-navigation-toggle"
          sx={{
            ...(darkMode && {
              background: '#1d1d1d',
              borderRight: '1px solid rgba(255, 255, 255, 0.33)',
              borderTop: ['1px solid rgba(255, 255, 255, 0.3)', 'inherit']
            }),
            ...(!darkMode && {
              background: 'beige'
            }),
            transitionDelay: '200ms',
            '&.is-active': {
              transitionDelay: '0ms',
              '.mobile-arrow': {
                transform: 'rotate(0deg)'
              },
              '.desktop-arrow': {
                transform: 'rotate(180deg)'
              }
            }
          }}
        >
          <div
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 16,
              transform: 'rotate(-90deg)',
              transformOrigin: '0 0',
              display: ['none', 'inline-flex'],
              alignItems: 'center'
            }}
          >
            <AccordionArrow
              className="arrow"
              style={{
                marginRight: 20,
                transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)'
              }}
              fill="currentColor"
            />
            <span
              sx={{
                transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)',
                letterSpacing: 0,
                fontFamily: 'heading',
                fontSize: 30
              }}
            >
              About
            </span>
          </div>
          <svg
            width="14"
            height="6"
            viewBox="0 0 14 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mobile-arrow"
            sx={{
              transform: 'rotate(180deg)',
              display: ['inline-flex', 'inline-flex', 'none']
            }}
          >
            <path d="M0.5 0.5L7 4.5L13.5 0.5" stroke="currentColor" />
          </svg>
          <span
            sx={{
              fontFamily: 'heading',
              marginLeft: 20,
              fontSize: 21,
              marginTop: 1,
              letterSpacing: 0,
              display: ['inline-flex', 'inline-flex', 'none']
            }}
          >
            About
          </span>
          <div className="js-date c-orange date" sx={{ display: 'none' }} />
        </div>

        <div className="navigation-modal js-navigation-modal pinFill bg-black">
          <a
            href="https://members.planque.co.uk/"
            className=""
            target="_blank"
            sx={{
              position: 'absolute !important',
              bottom: [72, 32],
              right: [16, 90],
              '&:before': { display: 'none' }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              fill="none"
              viewBox="0 0 44 44"
            >
              <path
                fill="#fff"
                d="M22 7a7 7 0 0 1 2.58 13.507L29 37H15.177l4.402-16.43A7.002 7.002 0 0 1 22 7"
              />
            </svg>
          </a>
          <div className="wrapper">
            <Navigation
              storeEnabled={storeEnabled}
              style={{ position: 'absolute', top: [48, 92] }}
            />

            <div>
              <ul
                className="secondary"
                sx={{
                  fontSize: [16, 24],
                  lineHeight: ['30px', '40px'],
                  position: 'absolute',
                  bottom: [72, 32]
                }}
              >
                <li>
                  <Link className="link" to="/faqs">
                    FAQs
                  </Link>
                </li>
                <li>
                  <Link className="link" to="/contact">
                    Contact
                  </Link>
                </li>
                <li>
                  <a
                    href="https://squareup.com/gift/MLJP0JSYHM240/order"
                    target="_blank"
                    className="link link-underline"
                  >
                    Gift Cards
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {pageTitle !== 'Shop' && (
          <div
            sx={{
              display: ['block', 'block', 'none'],
              position: 'fixed',
              height: 'calc(var(--vh, 1vh) * 100)',
              backgroundColor: darkMode ? '#1d1d1d' : 'beige',
              left: 0,
              width: '100vw',
              zIndex: reservationsOpen ? 5 : 3,
              boxShadow: darkMode
                ? '0 1px 0 0 rgba(255, 255,255, 0.3)'
                : '0 1px 0 0 #000000',
              transform: reservationsOpen
                ? 'translateY(0)'
                : 'translateY(-100%)',
              top: reservationsOpen ? 0 : 54,
              transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)'
            }}
          >
            <div
              sx={{
                position: 'absolute',
                top: 0,
                left: '0%',
                bg: 'beige',
                width: '100%',
                height: 'calc(var(--vh, 1dvh) * 100 - 56px)',
                overflow: 'scroll'
              }}
            >
              <iframe
                id="sevenrooms"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: '5%',
                  width: '90%',
                  height: 'calc(var(--vh, 1vh) * 100 - 50px)',
                  overflow: 'scroll',
                  paddingBottom: 30
                }}
                src="https://www.sevenrooms.com/reservations/planque"
              />
            </div>
            <div
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                height: 55,
                padding: '0 25px',
                display: 'flex',
                borderTop: '1px solid black',
                alignItems: 'center',
                right: 0
              }}
              onClick={() => {
                setReservationsOpen(!reservationsOpen)
              }}
            >
              <svg
                width="14"
                height="6"
                viewBox="0 0 14 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                sx={{
                  transform: reservationsOpen ? 'rotate(180deg)' : 'rotate(0)'
                }}
              >
                <path d="M0.5 0.5L7 4.5L13.5 0.5" stroke="currentColor" />
              </svg>

              <span
                sx={{
                  fontFamily: 'heading',
                  marginLeft: 20,
                  fontSize: 21,
                  marginTop: 1,
                  letterSpacing: 0
                }}
              >
                Reservations
              </span>
            </div>
          </div>
        )}

        <div
          className={`js-accordion accordion-menu heading ${
            title !== 'Home' ? 'is-collapsed' : ''
          }${reservationsHovered ? ' reservations-open' : ''}`}
          sx={{
            ...(darkMode && {
              background: '#1d1d1b',
              color: 'white',
              ul: {
                li: {
                  borderLeft: '1px solid rgba(255, 255, 255, 0.33)'
                }
              }
            })
          }}
        >
          <ul>
            {links.map((item, i) => {
              return (
                <li
                  key={`link-${i}`}
                  sx={{
                    width: 56,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    paddingLeft: 56,
                    transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)',
                    ...(item.title === 'Reservations' && {
                      width: reservationsHovered ? 500 : 56
                    }),
                    ...(item.title === 'Store' && {
                      background: 'black',
                      color: 'white'
                    }),
                    '#sevenrooms': {
                      opacity: reservationsHovered ? 1 : 0,
                      transform: reservationsHovered
                        ? 'translateY(-50%) translateX(-50%)'
                        : 'translateY(-50%) translateX(-40%)',
                      transition:
                        'all 1000ms cubic-bezier(0.075, 0.82, 0.165, 1)',
                      transitionDelay: !reservationsHovered ? '0ms' : '400ms'
                    }
                  }}
                >
                  {item.title === 'Reservations' && (
                    <iframe
                      id="sevenrooms"
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%) translateX(-50%)',
                        left: '50%',
                        maxWidth: 380,
                        width: '100%',
                        maxHeight: 640,
                        background: 'red',
                        height: '100%'
                      }}
                      src="https://www.sevenrooms.com/reservations/planque"
                    />
                  )}

                  <Link
                    to={item.link}
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: 56,
                      height: '100%',
                      '&:hover': {
                        span: {
                          marginLeft: '20px !important'
                        },
                        '.arrow': {
                          marginRight: 0,
                          marginLeft: 20
                        }
                      }
                    }}
                    className="link js-accordion-link"
                    onClick={(e) => {
                      e.preventDefault()
                      if (item.title === 'Reservations') {
                        const accordionMenu =
                          document.querySelector('.js-accordion')
                        accordionMenu.classList.remove('is-transitioning')
                        setReservationsHovered(!reservationsHovered)
                        return false
                      }
                      slowlyNavigate(item.link)
                    }}
                  >
                    {item.title === 'Reservations' && (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        sx={{
                          opacity: reservationsHovered ? 1 : 0,
                          position: 'absolute',
                          top: 20,
                          left: '50%',
                          marginLeft: -10
                        }}
                      >
                        <path d="M0 20L20 0M0 0L20 20" stroke="currentColor" />
                      </svg>
                    )}

                    <div
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 16,
                        transform: 'rotate(-90deg)',
                        transformOrigin: '0 0',
                        display: 'flex',
                        alignItems: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <AccordionArrow
                        className="arrow"
                        style={{
                          marginRight: 20,
                          transition:
                            'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)'
                        }}
                        fill="currentColor"
                      />
                      <span
                        sx={{
                          transition:
                            'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)',
                          letterSpacing: 0
                        }}
                      >
                        {item.title}
                      </span>

                      {/* {storeLabel && item.title === 'Store' && (
                        <span
                          sx={{
                            transition:
                              'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)',
                            letterSpacing: 0,
                            fontFamily: 'default',
                            fontSize: 23,
                            marginLeft: 20
                          }}
                        >
                          {storeLabel}
                        </span>
                      )} */}
                    </div>
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
        {children}
        {!hideFooter && <Footer />}
        <div
          sx={{
            position: 'fixed',
            bottom: [55, 30],
            left: [0, 86],
            maxWidth: 500,
            zIndex: 1
          }}
          className="js-holiday-modal"
        >
          <div
            sx={{
              backgroundColor: 'beige',
              borderTop: '1px solid black',
              borderLeft: ['none', '1px solid black'],
              borderRight: ['none', '1px solid black'],
              borderBottom: ['1px solid black'],
              padding: [30, 50],
              p: {
                fontSize: [14, 16]
              }
            }}
          >
            <h2 sx={{ mb: 10 }}>New Opening Times</h2>
            <p sx={{ mb: 20 }}>
              Starting from this summer our opening times are changing. From
              Tuesday 1st August onwards, our restaurant will be open for dinner
              from Tuesday to Saturday, and for lunch on Saturday as usual.
            </p>
            <h2 sx={{ mb: 10 }}>Summer Break</h2>
            <p>
              Our last day open before the holidays is Saturday 5th August. We
              will be back as usual from Tuesday 15th August.
            </p>
            <div
              className="js-modal-close"
              sx={{
                lineHeight: '40px',
                textAlign: 'center',
                textTransform: 'uppercase',
                height: 40,
                width: '100%',
                borderRadius: 20,
                outline: 'none',
                cursor: 'pointer',
                color: 'black',
                mt: 20,
                border: '1px solid black',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white'
                }
              }}
            >
              Close
            </div>
          </div>
        </div>
      </div>
      {pageTitle === 'Shop' && !hideCart && <Cart />}
    </>
  )
}

export default Layout
